module.exports = __webpack_public_path__ + "static/media/Vladimir.f6cf900a.png";